import React from 'react';
import PropTypes from 'prop-types';
import { RadioGroup } from '@quantum-ecosystem/ui-toolkit';

const FormRadioGroup = ({ label, withAsterisk, required, onBlur, className, ...props }) => (
	<div onBlurCapture={onBlur}>
		<RadioGroup
			{...props}
			label={label && (withAsterisk || required) ? <>{label}<span className="q-form-required"> *</span></> : label}
			className={className}
		/>
	</div>
);

FormRadioGroup.propTypes = {
	label: PropTypes.node,
	withAsterisk: PropTypes.bool,
	required: PropTypes.bool,
	onBlur: PropTypes.func,
	className: PropTypes.string,
	name: PropTypes.string.isRequired,
	options: PropTypes.array.isRequired,
	value: PropTypes.any,
	onChange: PropTypes.func,
	error: PropTypes.node,
	hint: PropTypes.node,
	orientation: PropTypes.oneOf(['vertical', 'horizontal']),
};

export default FormRadioGroup;
